<template>
  <div class="email-container">
    <h2>Email settings</h2>
    <p class="body">Manage your subscriptions here. Select the topics you would like to receive branded newsletters
      from:
    </p>

    <div class="options">
      <label class="input-checkbox">Company News
        <input type="checkbox" v-model="subscribedToCompanyNews">
        <span class="checkmark"></span>
      </label>

      <label class="input-checkbox">Trading News (Surf's up newsletter)
        <input type="checkbox" v-model="subscribedToTradingNews">
        <span class="checkmark"></span>
      </label>
    </div>

    <button class="red-button" @click="update">Update</button>
    <p class="instructions">If you no longer want to receive emails on any of the above topics, just uncheck them. Do
      not forget to click update.
    </p>
  </div>
</template>

<script>
import {API} from "@aws-amplify/api";
import {graphqlOperation} from "@aws-amplify/api-graphql";
import {createPreference, updatePreference, updateUser} from "@/graphql/mutations";

export default {
  name: "Email",
  data() {
    return {
      subscribedToCompanyNews: true,
      subscribedToTradingNews: true,
    };
  },
  created() {
    let userInfo = this.$store.state.user;
    if (userInfo != null) {
      if (userInfo.preference != null && userInfo.preference.subscribedToCompanyNews != null) {
        this.subscribedToCompanyNews = userInfo.preference.subscribedToCompanyNews;
      } else {
        this.subscribedToCompanyNews = true;
      }
      if (userInfo.preference != null && userInfo.preference.subscribedToTradingNews != null) {
        this.subscribedToTradingNews = userInfo.preference.subscribedToTradingNews;
      } else {
        this.subscribedToTradingNews = true;
      }
    }
  },
  methods: {
    update() {
      console.log('update!');
      let userInfo = this.$store.state.user;
      if (userInfo != null) {
        if (userInfo.preference == null) {
          //  TODO: SHOULD BE DONE IN A TRANSACTION!!!
          API.graphql(graphqlOperation(createPreference, {
            input: {
              subscribedToCompanyNews: this.subscribedToCompanyNews,
              subscribedToTradingNews: this.subscribedToTradingNews
            }
          })).then((result) => {
            console.log('--- CREATE PREFERENCE ---');
            console.log(result);

            if (result.data != null && result.data.createPreference != null) {
              API.graphql(graphqlOperation(updateUser, {
                input: {
                  id: userInfo.id,
                  userPreferenceId: result.data.createPreference.id
                }
              })).then((result) => {
                console.log('--- UPDATE USER ---');
                console.log(result);
              }).catch((error) => {
                console.log(error);
              });
            } else {
              //  TODO: implement!
              console.log('ERROR!!!');
            }

          }).catch((error) => {
            console.log(error);
          });
        } else {
          API.graphql(graphqlOperation(updatePreference, {
            input: {
              id: userInfo.preference.id,
              subscribedToCompanyNews: this.subscribedToCompanyNews,
              subscribedToTradingNews: this.subscribedToTradingNews
            }
          })).then((result) => {
            console.log('--- UPDATE PREFERENCE ---');
            console.log(result);
          }).catch((error) => {
            console.log(error);
          });
        }

        //  TODO: SHOULD REFRESH THE USER APP-WISE!!!
      }
    }
  }
}
</script>

<style scoped>

</style>
